<template>
  <div>
    <h3><span class="fw-semi-bold">Missed </span>Checkups</h3>
    <p>
      Patient Checkups missed/incomplete.
    </p>
    <div class="table-responsive">
      <table class="table table-hover">
        <thead>
        <tr>
          <th>#</th>
          <th>Patient</th>
          <th>Start Time</th>
          <th>Action(s)</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="(missedCheckup, index) in missedCheckups" :key="missedCheckup.id">
          <td>{{ index + 1 }}</td>
          <td>{{ missedCheckup.patient.name }}</td>
          <td>{{ missedCheckup.start_time }}</td>
          <td>
            <b-button variant="outline-success" size="xs"
                      @click="makeAppointmentCall(missedCheckup)">
              call
            </b-button>

            <b-button variant="outline-warning" size="xs"
                      @click="showEndCallModal = true">
              terminate
            </b-button>
            <!--    form to end call for checkup-->
            <b-modal id="modal-center" v-model="showEndCallModal" centered title="Finish Checkup">
              <b-form>
                <b-row>
                  <b-col>
                    <b-form-group label="Tags :" label-for="patient_tags">
                      <b-form-checkbox-group
                          v-model="callTerminateForm.patient_tags"
                          name="patient_tags"
                          :options="patientTags"
                          class="mb-3"
                          value-field="item"
                          text-field="name"
                          disabled-field="notEnabled"
                      ></b-form-checkbox-group>
                    </b-form-group>
                  </b-col>
                </b-row>
              </b-form>

              <template v-slot:modal-footer>
                <b-button size="sm" variant="success" @click="confirmCallTerminate(missedCheckup)">
                  Confirm
                </b-button>
                <b-button size="sm" variant="danger" @click="showEndCallModal = false">
                  Cancel
                </b-button>

              </template>
            </b-modal>
            <!--    form to end call for checkup-->
          </td>
        </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import {Form} from "vform";
import CheckupService from './../../../services/checkup.service';

export default {
  name: "MissedCheckups",
  props: ['doctor'],
  data() {
    return {
      showEndCallModal: false,
      missedCheckups: [],
      patientTags: [
        {item: 'fraud', name: 'fraud'},
      ],
      callTerminateForm: new Form({
        start_time: new Date(),
        end_time: '',
        status: 1,
        patient_rating: 5,
        patient_tags: []
      }),
    }
  },
  methods: {
    loadMissedCheckups() {
      CheckupService.fetchMissedCheckupsByDoctor(this.doctor.id)
          .then((response) => {
            if (response.status === 200) {
              this.missedCheckups = response.data;
            }
          })
          .catch((e) => console.error(e));
    },
    makeAppointmentCall(patientcheckup) {
      let routeData = this.$router.resolve({name: 'doctorCheckup', params: {patientcheckup_code: patientcheckup.code}});
      window.open(routeData.href, '_blank', 'location=yes,channelmode=yes,fullscreen=yes,scrollbars=yes,status=yes');
    },

    confirmCallTerminate(patientcheckup) {
      this.callTerminateForm.end_time = new Date();
      CheckupService.editCheckupAfterCall(patientcheckup.checkup_code, this.callTerminateForm)
          .then((response) => {
            if (response.status === 204) {
              this.showEndCallModal = false;
              this.callTerminateForm.reset();
              localStorage.setItem('endcall', "true");
              this.loadMissedCheckups();
            }
          });
    }
  },
  mounted() {
    this.loadMissedCheckups();
    setInterval(() => {
      this.loadMissedCheckups();
    }, 60000 * 10)
  }
}
</script>

<style scoped>

</style>